import React from 'react'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import SortIcon from '@mui/icons-material/Sort'
import CheckIcon from '@mui/icons-material/Check'
import { useTranslation } from 'react-i18next'

const DEFAULT_OPTIONS = [
  { name: 'Dostępności', value: 'availability' },
  { name: 'Cena: rosnąco', value: 'asc' },
  { name: 'Cena: malejąco', value: 'desc' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

// Sterowany: wybór trzyma rodzic (value + onSortChange). options konfigurowalne.
// Nazwa opcji to polski tekst domyślny; wyświetlamy tłumaczenie po `value`
// (lista:sortowanie.<value>), a gdy go brak, samą nazwę.
const Sort = ({ onSortChange, value, options = DEFAULT_OPTIONS }) => {
  const { t } = useTranslation('lista')
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="group inline-flex items-center justify-center text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 border border-blue-600 px-3 py-1.5 rounded-md transition-colors">
          {t('sortowanie.przycisk')}
          <SortIcon fontSize='small' className="-mr-1 ml-1" aria-hidden="true" />
        </MenuButton>
      </div>

      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {options.map((option) => (
              <MenuItem key={option.value}>
                <button
                  onClick={() => onSortChange(option.value)}
                  className={classNames(
                    value === option.value ? 'font-medium text-gray-900 bg-gray-100' : 'text-gray-500',
                    'flex items-center gap-2 px-4 py-2 text-sm w-full text-left'
                  )}
                >
                  {value === option.value && (
                    <CheckIcon fontSize="small" className="text-gray-500" />
                  )}
                  {t(`sortowanie.${option.value}`, { defaultValue: option.name })}
                </button>
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  )
}

export default Sort
